export default "__VITE_ASSET__BUHGL$jp__"